import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class NotificationsHttpService {

  public static HISTORY_URL = DevelopUtil.url('information');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getHistory(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(NotificationsHttpService.HISTORY_URL, this.requestOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/notifications/notifications.http.service.ts